module.exports = __webpack_public_path__ + "img/ys-nine-grid.5f3be1d2.png";